import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";

import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 20,
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: 20,
    border: `2px solid ${theme.palette.primary}`,
    alignItems: "center",
    borderRadius: 10,
    justifyContent: "center",
    WebkitJustifyContent: "center",
    display: "flex",
  },
}));

export default function Loading(props) {
  const classes = useStyles();
  const { visible } = props;

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={visible}
      // onClose={handleClose}
      closeAfterTransition
      //  BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <div className={classes.paper}>
        <Spinner color="#727981" size={25} speed={1} animating={true} />
        <Typography
          style={{ fontSize: 20, marginLeft: 22, fontWeight: "bold" }}
        >
          Favor Espere...
        </Typography>
      </div>
    </Modal>
  );
}
